import React, {Component} from 'react';
import Actionbar from "../Common/Actionbar";
import Navbar from "../Common/Navbar";
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {
    faSignOutAlt,
    faAngleLeft,

    faUserEdit, faLightbulb, faCheck, faCoins, faPhoneAlt, faList


} from '@fortawesome/free-solid-svg-icons'
import NoPic from "../../assets/images/emptypic.png"
import API from "../../services/API";

//const currencyFormat = Intl.NumberFormat('en-US');
class Profile extends Component {
    state ={
        user:[],
        cartItemCount : 0
    }
    onExitClick = () => {
        localStorage.clear();
        document.cookie = "auth=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
        window.location.replace("/")
    }
    render() {
        return (
            <React.Fragment>
                <Actionbar noBack={1} title=' پروفایل'  />
                <main className="container-fluid  pt-3">
                    <div className="row px-3 ">
                        <div className="col-12 rtl profile-header" onClick={()=>this.props.history.push('/edit-profile') }>
                            <div className="card-body pt-4">
                                <div className="row" >
                                    <div className="col-3">
                                        <img src={this.state.user.avatar ? this.state.user.avatar : NoPic } className="rounded-circle mx-auto d-block" alt={this.state.user.first_name} width="70px" height="70px"/>
                                    </div>
                                    <div className="col-9">
                                        <div className=" fw-bold pt-2">{this.state.user.first_name} {this.state.user.last_name}</div>
                                        <span className=" super-small-2 ltr">
                                            {this.state.user.mobile ? this.state.user.mobile.replace('+98' , '0') : ''}
                                        </span>
                                        <div className="profile-edit-user">
                                            ویرایش
                                            &nbsp;
                                            <FontAwesomeIcon icon={faUserEdit} className='text-big' />
                                        </div>
                                    </div>

                                </div>

                            </div>
                        </div>

                    </div>

                    <div className="container-fluid profile-list-items">
                        <div className="row mt-4 rtl px-4 menu-list-item"
                             onClick={() => this.props.history.push('/work-shifts')}>

                            <div className="col-1">
                                <FontAwesomeIcon icon={faCheck} className="text-success"/>
                            </div>
                            <div className="col-10 text-dark menu-text ">
                                مدیریت شیفت های کاری

                            </div>
                            <div className="col-1">
                                <FontAwesomeIcon icon={faAngleLeft}/>
                            </div>

                        </div>
                        <div className="row mt-4 rtl px-4 menu-list-item"
                             onClick={() => this.props.history.push('/finance')}>

                            <div className="col-1">
                                <FontAwesomeIcon icon={faCoins} className="text-primary"/>
                            </div>
                            <div className="col-10 text-dark menu-text ">
                                گزارش مالی

                            </div>
                            <div className="col-1">
                                <FontAwesomeIcon icon={faAngleLeft}/>
                            </div>

                        </div>
                        <div className="row mt-4 rtl px-4 menu-list-item"
                             onClick={() => this.props.history.push('/history')}>

                            <div className="col-1">
                                <FontAwesomeIcon icon={faList} className="text-secondary"/>
                            </div>
                            <div className="col-10 text-dark menu-text ">
                                تاریخچه لیست سیاه

                            </div>
                            <div className="col-1">
                                <FontAwesomeIcon icon={faAngleLeft}/>
                            </div>

                        </div>
                        <div className="row mt-4 rtl px-4 menu-list-item"
                             onClick={() => this.props.history.push('/contents/guide')}>

                            <div className="col-1">
                                <FontAwesomeIcon icon={faLightbulb} className="text-info"/>
                            </div>
                            <div className="col-10 text-dark menu-text ">
                                راهنمای اپلیکیشن
                            </div>
                            <div className="col-1">
                                <FontAwesomeIcon icon={faAngleLeft}/>
                            </div>

                        </div>

                        <div className="row mt-4 rtl px-4 menu-list-item " onClick={this.onExitClick}>

                            <div className="col-1">
                                <FontAwesomeIcon icon={faSignOutAlt} className="text-warning"/>
                            </div>
                            <div className="col-10 text-dark menu-text ">
                                خروج از حساب کاربری
                            </div>
                            <div className="col-1">
                                <FontAwesomeIcon icon={faAngleLeft}/>
                            </div>

                        </div>
                        <a href='tel:09150100691'
                           className="row mt-4 rtl px-4 menu-list-item border-bottom-0 text-decoration-none">

                            <div className="col-1">
                                <FontAwesomeIcon icon={faPhoneAlt} className="text-success"/>
                            </div>
                            <div className="col-10 text-dark menu-text ">
                                تماس با پشتیبانی
                                (09150100691)
                            </div>
                            <div className="col-1">
                                <FontAwesomeIcon icon={faAngleLeft}/>
                            </div>

                        </a>
                    </div>
                </main>
                <Navbar/>
            </React.Fragment>
        );
    }

    componentDidMount = () => {

        API.index()
            .then((response) => {

                this.setState(response.results)
            })
    }
}

export default Profile;
